import React, { Component, useEffect, useState } from "react";
import Breadcrumb from "../../elements/common/Breadcrumb";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/Footer";
import controllers from "../../controllers/teams";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Preloader from "../../component/Preloader/Preloader";
import { useLoading } from "../../LoadingContext";

const TeamDetails = () => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const teamId = searchParams.get("id");
  const [data, setData] = useState(false);
  const { loading, setLoading } = useLoading();
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  useEffect(() => {
    setLoading(true);
    const getTeamDetails = () => {
      if (teamId) {
        return controllers
          .getTeamDetails(teamId)
          .then((response) => {
            setData(response);
          })
          .catch((error) => {
            window.location.href = "/404";
          })
          .finally(() => {
            setTimeout(() => {
              setLoading(false); // set loading to false when data is fetched
            }, 4000);
          });
      } else {
        setLoading(false);
        window.location.href = "/404";
      }
    };
    setTimeout(() => {
      getTeamDetails();
    }, 800);
  }, [teamId]);

  if (loading) {
    return <Preloader />;
  }

  return (
    <React.Fragment>

      <Header
        headertransparent="header--transparent"
        colorblack="color--black"
        logoname="logo.png"
      />

      {data && (
        <>
          <Breadcrumb parent="Team" title={data.fullname} />

          <div className="rn-service-details ptb--120 bg_color--1">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="service-details-inner">
                    <div className="inner">
                      <div className="row row--35 sercice-details-content align-items-center">
                        <div className="col-lg-4 col-12">
                          <div className="thumb position-relative">
                            <img
                              className="w-100"
                              src={
                                data.avatar !== "team_avatar.jpg"
                                  ? `${process.env.REACT_APP_DOMAIN}/api/teamavatars/${data._id}/${data.avatar}`
                                  : `${process.env.REACT_APP_DOMAIN}/api/teamavatars/${data.avatar}`
                              }
                              alt="Team"
                              style={{ height: "500px", objectFit: "cover" }}
                            />
                          </div>
                        </div>
                        <div className="col-lg-8 col-12">
                          <div className="details mt_md--30 mt_sm--30">
                            <div className="section-title">
                              <span className="subtitle">{data.status}</span>
                              <h2 className="title">{data.fullname}</h2>

                              {isEnglish ? (
                                <p
                                  className="description"
                                  dangerouslySetInnerHTML={{
                                    __html: data.biography && data.biography.en,
                                  }}
                                  className=""
                                ></p>
                              ) : (
                                <p
                                  className="description"
                                  dangerouslySetInnerHTML={{
                                    __html: data.biography && data.biography.fr,
                                  }}
                                  className=""
                                ></p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div className="backto-top">
            <ScrollToTop showUnder={160}>
              <FiChevronUp />
            </ScrollToTop>
          </div>
        </>
      )}

      <Footer />
    </React.Fragment>
  );
};
export default TeamDetails;
